module.exports = __webpack_public_path__ + "static/media/designer-black-background.43056ad0.jpg";